import React from 'react';
import { Box, Heading, Link, Text, VStack } from '@chakra-ui/react';

const TermsAndConditions = () => {
  return (
    <Box p={['5', '32']} className="backcolor" mt={'5vh'}>
      <VStack alignItems="flex-start" spacing="4">
        <Heading as="h1" fontSize="4xl" mb="4">
          Terms & Conditions
        </Heading>
        <Text fontSize="lg" fontWeight="bold">
          Updated at 25-09-2023
        </Text>
        <Heading as="h2" fontSize="2xl">
          General Terms
        </Heading>
        <Text>
          By accessing and placing an order with LearnWiz, you confirm that you
          are in agreement with and bound by the terms of service contained in
          the Terms & Conditions outlined below. These terms apply to the entire
          website and any email or other type of communication between you and
          LearnWiz.
        </Text>
        <Text>
          Under no circumstances shall LearnWiz team be liable for any direct,
          indirect, special, incidental or consequential damages, including, but
          not limited to, loss of data or profit, arising out of the use, or the
          inability to use, the materials on this site, even if LearnWiz team or
          an authorized representative has been advised of the possibility of
          such damages. If your use of materials from this site results in the
          need for servicing, repair or correction of equipment or data, you
          assume any costs thereof.
        </Text>
        <Text>
          LearnWiz will not be responsible for any outcome that may occur during
          the course of usage of our resources. We reserve the rights to change
          prices and revise the resources usage policy in any moment.
        </Text>
        <Heading as="h2" fontSize="2xl">
          Restrictions
        </Heading>
        <Text>You agree not to, and you will not permit others to:</Text>
        <Text>
          - License, sell, rent, lease, assign, distribute, transmit, host,
          outsource, disclose or otherwise commercially exploit the website or
          make the platform available to any third party.
          <br />
          - Modify, make derivative works of, disassemble, decrypt, reverse
          compile or reverse engineer any part of the website.
          <br />- Remove, alter or obscure any proprietary notice (including any
          notice of copyright or trademark) of LearnWiz or its affiliates,
          partners, suppliers or the licensors of the website.
        </Text>
        <Heading as="h2" fontSize="2xl">
          Modifications to Our website
        </Heading>
        <Text>
          LearnWiz reserves the right to modify, suspend or discontinue,
          temporarily or permanently, the website or any service to which it
          connects, with or without notice and without liability to you.
        </Text>
        <Heading as="h2" fontSize="2xl">
          Updates to Our website
        </Heading>
        <Text>
          LearnWiz may from time to time provide enhancements or improvements to
          the features/ functionality of the website, which may include patches,
          bug fixes, updates, upgrades and other modifications ("Updates").
        </Text>
        <Text>
          Updates may modify or delete certain features and/or functionalities
          of the website. You agree that LearnWiz has no obligation to (i)
          provide any Updates, or (ii) continue to provide or enable any
          particular features and/or functionalities of the website to you.
        </Text>
        <Text>
          You further agree that all Updates will be (i) deemed to constitute an
          integral part of the website, and (ii) subject to the terms and
          conditions of this Agreement.
        </Text>
        <Heading as="h2" fontSize="2xl">
          Third-Party Services
        </Heading>
        <Text>
          We may display, include or make available third-party content
          (including data, information, applications and other products
          services) or provide links to third-party websites or services
          ("Third- Party Services").
        </Text>
        <Text>
          You acknowledge and agree that LearnWiz shall not be responsible for
          any Third-Party Services, including their accuracy, completeness,
          timeliness, validity, copyright compliance, legality, decency, quality
          or any other aspect thereof. LearnWiz does not assume and shall not
          have any liability or responsibility to you or any other person or
          entity for any Third-Party Services.
        </Text>
        <Text>
          Third-Party Services and links thereto are provided solely as a
          convenience to you and you access and use them entirely at your own
          risk and subject to such third parties' terms and conditions.
        </Text>
        <Heading as="h2" fontSize="2xl">
          Term and Termination
        </Heading>
        <Text>
          This Agreement shall remain in effect until terminated by you or
          LearnWiz.
        </Text>
        <Text>
          LearnWiz may, in its sole discretion, at any time and for any or no
          reason, suspend or terminate this Agreement with or without prior
          notice.
        </Text>
        <Text>
          This Agreement will terminate immediately, without prior notice from
          LearnWiz, in the event that you fail to comply with any provision of
          this Agreement. You may also terminate this Agreement by deleting the
          website and all copies thereof from your computer.
        </Text>
        <Text>
          Upon termination of this Agreement, you shall cease all use of the
          website and delete all copies of the website from your computer.
        </Text>
        <Text>
          Termination of this Agreement will not limit any of LearnWiz's rights
          or remedies at law or in equity in case of breach by you (during the
          term of this Agreement) of any of your obligations under the present
          Agreement.
        </Text>
        <Heading as="h2" fontSize="2xl">
          Copyright Infringement Notice
        </Heading>
        <Text>
          If you are a copyright owner or such owner’s agent and believe any
          material on our website constitutes an infringement on your copyright,
          please contact us setting forth the following information: (a) a
          physical or electronic signature of the copyright owner or a person
          authorized to act on his behalf; (b) identification of the material
          that is claimed to be infringing; (c) your contact information,
          including your address, telephone number, and an email; (d) a
          statement by you that you have a good faith belief that use of the
          material is not authorized by the copyright owners; and (e) the a
          statement that the information in the notification is accurate, and,
          under penalty of perjury you are authorized to act on behalf of the
          owner.
        </Text>
        <Heading as="h2" fontSize="2xl">
          No Warranties
        </Heading>
        <Text>
          The website is provided to you "AS IS" and "AS AVAILABLE" and with all
          faults and defects without warranty of any kind. To the maximum extent
          permitted under applicable law, LearnWiz, on its own behalf and on
          behalf of its affiliates and its and their respective licensors and
          service providers, expressly disclaims all warranties, whether
          express, implied, statutory or otherwise, with respect to the website,
          including all implied warranties of merchantability, fitness for a
          particular purpose, title and non-infringement, and warranties that
          may arise out of course of dealing, course of performance, usage or
          trade practice. Without limitation to the foregoing, LearnWiz provides
          no warranty or undertaking, and makes no representation of any kind
          that the website will meet your requirements, achieve any intended
          results, be compatible or work with any other software, systems or
          services, operate without interruption, meet any performance or
          reliability standards or be error free or that any errors or defects
          can or will be corrected.
        </Text>
        <Text>
          Without limiting the foregoing, neither LearnWiz nor any LearnWiz's
          provider makes any representation or warranty of any kind, express or
          implied: (i) as to the operation or availability of the website, or
          the information, content, and materials or products included thereon;
          (ii) that the website will be uninterrupted or error-free; (iii) as to
          the accuracy, reliability, or currency of any information or content
          provided through the website; or (iv) that the website, its servers,
          the content, or e-mails sent from or on behalf of LearnWiz are free of
          viruses, scripts, trojan horses, worms, malware, timebombs or other
          harmful components.
        </Text>
        <Text>
          Some jurisdictions do not allow the exclusion of or limitations on
          implied warranties or the limitations on the applicable statutory
          rights of a consumer, so some or all of the above exclusions and
          limitations may not apply to you.
        </Text>
        <Heading as="h2" fontSize="2xl">
          Limitation of Liability
        </Heading>
        <Text>
          Notwithstanding any damages that you might incur, the entire liability
          of LearnWiz and any of its suppliers under any provision of this
          Agreement and your exclusive remedy for all of the foregoing shall be
          limited to the amount actually paid by you for the website.
        </Text>
        <Text>
          To the maximum extent permitted by applicable law, in no event shall
          LearnWiz or its suppliers be liable for any special, incidental,
          indirect, or consequential damages whatsoever (including, but not
          limited to, damages for loss of profits, for loss of data or other
          information, for business interruption, for personal injury, for loss
          of privacy arising out of or in any way related to the use of or
          inability to use the website, third-party software and/or third-party
          hardware used with the website, or otherwise in connection with any
          provision of this Agreement), even if LearnWiz or any supplier has
          been advised of the possibility of such damages and even if the remedy
          fails of its essential purpose.
        </Text>
        <Text>
          Some states/jurisdictions do not allow the exclusion or limitation of
          incidental or consequential damages, so the above limitation or
          exclusion may not apply to you.
        </Text>
        <Heading as="h2" fontSize="2xl">
          Amendments to this Agreement
        </Heading>
        <Text>
          LearnWiz reserves the right, at its sole discretion, to modify or
          replace this Agreement at any time. If a revision is material we will
          provide at least 30 days' notice prior to any new terms taking effect.
          What constitutes a material change will be determined at our sole
          discretion.
        </Text>
        <Text>
          By continuing to access or use our website after any revisions become
          effective, you agree to be bound by the revised terms. If you do not
          agree to the new terms, you are no longer authorized to use LearnWiz.
        </Text>
        <Heading as="h2" fontSize="2xl">
          Entire Agreement
        </Heading>
        <Text>
          The Agreement constitutes the entire agreement between you and
          LearnWiz regarding your use of the website and supersedes all prior
          and contemporaneous written or oral agreements between you and
          LearnWiz.
        </Text>
        <Text>
          You may be subject to additional terms and conditions that apply when
          you use or purchase other LearnWiz's services, which LearnWiz will
          provide to you at the time of such use or purchase.
        </Text>
        <Heading as="h2" fontSize="2xl">
          Updates to Our Terms
        </Heading>
        <Text>
          We may change our Service and policies, and we may need to make
          changes to these Terms so that they accurately reflect our Service and
          policies. Unless otherwise required by law, we will notify you (for
          example, through our Service) before we make changes to these Terms
          and give you an opportunity to review them before they go into effect.
          Then, if you continue to use the Service, you will be bound by the
          updated Terms. If you do not want to agree to these or any updated
          Terms, you can delete your account.
        </Text>
        <Heading as="h2" fontSize="2xl">
          Intellectual Property
        </Heading>
        <Text>
          The website and its entire contents, features and functionality
          (including but not limited to all information, software, text,
          displays, images, video and audio, and the design, selection and
          arrangement thereof), are owned by LearnWiz, its licensors or other
          providers of such material and are protected by IL and international
          copyright, trademark, patent, trade secret and other intellectual
          property or proprietary rights laws. The material may not be copied,
          modified, reproduced, downloaded or distributed in any way, in whole
          or in part, without the express prior written permission of LearnWiz,
          unless and except as is expressly provided in these Terms &
          Conditions. Any unauthorized use of the material is prohibited.
        </Text>
        <Text mt="4" fontWeight={'bold'}>
          For more information about these terms, please{' '}
          <Link color="rgb(12,120,254)" to="/contact">
            contact us
          </Link>
          .
        </Text>
        <Heading as="h2" fontSize="2xl" mt="4">
          Contact Us
        </Heading>
        <Text>Don't hesitate to contact us if you have any questions.</Text>
        <Text>Via Email: [khanwarish483@gmail.com]</Text>
        <Text>Via Phone Number: +919991463786</Text>
        <Text>At Office : Ferozepur Jhirka Nuh(mewat) Haryana - 122104.</Text>
      </VStack>
    </Box>
  );
};

export default TermsAndConditions;
